import React, { Component } from 'react';
import styles from './ratePopupPlan.scss';
import ToggleButton from '../../Common/CommonComponents/CustomToggleButton/customToggleButton';
import AnchorTag from '../../Common/CommonComponents/CustomAnchorTag/customAnchorTag';
import ErrorCard from '../../Dashboard/Common/errorCard';
import LoadIndicator from '../../Common/CommonComponents/LoadingIndicator/loadingIndicator';
import ReactHtmlParser from 'react-html-parser';
import FocusTrap from "focus-trap-react";
import YourRatePlanGraphView from './ratePopupGraph';
import InfoPopup from '../../Dashboard/Common/infoPopup';
import { getLocalizedStrings } from '../../Dashboard/dashboardLocalizedStrings';
export default class RatePopupPlan extends Component {
    constructor(props) {
        super(props);
        this.currentRate = ['June', 'July', 'August', 'September'].includes(new Date().toLocaleString("default", { month: "long" }));
        this.state = {
            ratePlanResponse: null, isDataLoading: true, rateCategory:'',cutOffDate : new Date(drupalSettings.custom.globalInformation.setvals.huc_date.replace(/"/g, '')),currentDate:new Date(),
            ratePlanValuesTOU: [{heading: 'Time-Of-Use', subHeading: this.currentRate ? 'On-Peak' : 'Super Off-Peak', subHeadingTwo: '(Weekdays Only)', colValue: 'col-sm-5', className: styles.superOffPeak,},
                {heading: 'Hours', subHeading: 'Mid-Peak', subHeadingTwo: '(Weekends Only)', colValue: 'col-sm-3', className: styles.midPeak},
                {heading: 'Rates', subHeading: 'Off-Peak', subHeadingTwo: '', colValue: 'col-sm-4', className: styles.offPeak}],
            weekDayRatePlanValuesTOU: [ {subHeading: 'Off-Peak', colValue: 'col-sm-5', className: styles.offPeak, },
                {subHeading: 'On-Peak', colValue: 'col-sm-3', className: styles.onPeak},
                {subHeading: 'Off-Peak', subHeadingTwo: '', colValue: 'col-sm-4', className: styles.offPeak}],
            weekendRatePlanValuesTOU: [{subHeading: 'Off-Peak', colValue: 'col-sm-5', className: styles.offPeak,},
                {subHeading: 'Mid-Peak', colValue: 'col-sm-3', className: styles.midPeak },
                {subHeading: 'Off-Peak', colValue: 'col-sm-4', className: styles.offPeak }],
            isError: false, summerPeakValues: [], winterPeakValues: [], rateOptions: ['Summer Rates', 'Winter Rates'], rateCategoryType: this.props.rateCategory,
            summerPeakTitle:[],winterPeakTitle:[],summerPeakWeekText:[],winterPeakWeekText:[],
            summerWeekDayPeak:[], summerWeekEndPeak:[], winterWeekDayPeak:[], winterWeekEndPeak:[], winterWeekDayCols:[],winterWeekEndCols:[],summerWeekDayCols:[],summerWeekEndCols:[],summerWeekDayEndSame:false,winterWeekDayEndSame:false,
            selectedRateOption: this.currentRate ? 'Summer Rates' : 'Winter Rates', summerRateHours: [], winterRateHours: [], highestRateDaily: '', 
            ratePlanValuesTier: [{heading: 'Tier', subHeading: 'Tier 1', colValue: 'col-sm-4', className: styles.tierOne},
                {heading: 'Rate/kWh', subHeading: 'Tier 2', colValue: 'col-sm-4', className: styles.tierTwo },
                {heading: 'Tier Range (kWh)', subHeading: 'High Usage', colValue: 'col-sm-4', className: styles.tierThree} ],
            ratePlanValuesTierMobile: [{heading: 'Tier Range (kWh)', subHeading: 'High Usage', colValue: 'col-sm-4', className: styles.tierThree},
                {heading: 'Rate/kWh', subHeading: 'Tier 2', colValue: 'col-sm-4', className: styles.tierTwo }, 
                {heading: 'Tier', subHeading: 'Tier 1', colValue: 'col-sm-4', className: styles.tierOne},],
            ratePlanValuesFlat: [{heading: 'Tier', subHeading: 'Tier 1'},
                {heading: 'Rate/kWh',}],
            tierRateValues: [], summerPeakGraphWeekend: [], summerPeakGraphWeekday: [], flatRateSummerValues: [], flatRateWinterValues: [],
        };
        this.setWrapperRef = this.setWrapperRef.bind(this),this.handleClickOutside = this.handleClickOutside.bind(this);
        this.showGraphViewTOU = YourRatePlanGraphView.showGraphViewTOU.bind(this),this.showGraphViewTier = YourRatePlanGraphView.showGraphViewTier.bind(this);
        this.showTableViewFlat = YourRatePlanGraphView.showTableViewFlat.bind(this),this.showFlatcontent = YourRatePlanGraphView.showFlatcontent.bind(this);
        this.sortPeak = YourRatePlanGraphView.sortPeak.bind(this);
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.billStrings = getLocalizedStrings('yourBill');
        this.nbtHeading = <span className={styles.sceYourBillCardTitleHead}> Solar Billing Plan </span>;
     }

componentDidMount() {
        this.handleAccountSortCall();
        document.addEventListener('click', this.handleClickOutside);
    }

componentWillUnmount() { 
        document.removeEventListener('click', this.handleClickOutside);
    }
    
    componentDidUpdate() {
        document.addEventListener('click', this.handleClickOutside);
    }

setWrapperRef(node) {
        this.wrapperRef = node;}
    
    handleClickOutside(event) {
        (this.wrapperRef && !this.wrapperRef.contains(event.target) && !event.target.innerHTML.includes('refresh Icon')) && this.props.ratePlanOpenClosePopup('close');
    }

    handleAccountSortCall=()=>{
        !this.state.isDataLoading ? this.setState({ isDataLoading: true }) : null;
        let reqObj = { businessPartnerId: this.props.buisnessPartnerNumber, contractAccountNumber:this.props.contractAccountNumber, contractNumber: this.props.contractNumber, idProgramClass:"BAS", processType:"01" };
        app.settingsService.getCostDetails(reqObj).then(
            (response)=>{
                if (response && !response.errorCode) {
                    this.setState({costDetails:response.costDetailsResponse[0]});
                    this.fetchRatePlan();
                }else{
                    this.setState({isDataLoading:false});}
            },(error) => {this.setState({ isDataLoading:false });}
);}

compareRatePlans = () => {
        let events = { alertDismissed: false, alertInteracted: false, manageAccount: false, makePayment: false, autoPayEnroll: false, paperlessEnroll: false, viewBill: false, viewUsage: false, custom: false, autopayCancel: false, paperlessCancel: false, sdpEnroll: false, sepEnroll: false, savingsPlan: false, paymentArrangement: false, componentClick: true, componentName: 'Your Rate Plan' };
        app.analyticsService.addPageLevelData('eventCapturing', events);        
        window.aUtils ? window.aUtils.sendAAEvent("link", `settings|accounts|none|none|page|compare_rate_plan`) : null;
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().MYACCOUNT.RESIDENTIAL_RATE_PLAN_COMPARISION);
    }
fetchRatePlan = () => {
        !this.state.isDataLoading ? this.setState({ isDataLoading: true }) : null;
        app.settingsService.getRatePlan(this.props.contractNumber).then(
            (response) => {
                if(!response.errorCode){
                if (response.isTierOrTOU === 'TIER') {
                    this.setState({ isError: false, ratePlanResponse: response, tierRateValues: [response.tier1Value, response.tier2Value, response.tier3Value], isDataLoading: false, rateCategory: response.rateCategory });
                } else if (response.isTierOrTOU === 'GS') {
                    this.setState({ isError: false, ratePlanResponse: response, flatRateSummerValues: [response.summerTier1Value], flatRateWinterValues: [response.winterTier1Value], isDataLoading: false, rateCategory: response.rateCategory });
                } else {
                    let respResult = this.formatReponseForTOU(response);
                    this.setState({...this.state, isError: false, ratePlanResponse: response, summerPeakWeekText:respResult.summerPeakWeekText, winterPeakWeekText:respResult.winterPeakWeekText, summerPeakTitle:respResult.summerPeakTitle, winterPeakTitle:respResult.winterPeakTitle,  winterPeakValues: respResult.winterPeakValues, summerPeakValues: respResult.summerPeakValues, summerRateHours: respResult.summerRateHours, winterRateHours: respResult.winterRateHours, summerWeekDayPeak:respResult.summerWeekDayPeak, summerWeekEndPeak:respResult.summerWeekEndPeak, winterWeekDayPeak:respResult.winterWeekDayPeak, winterWeekEndPeak:respResult.winterWeekEndPeak, winterWeekDayCols:respResult.winterWeekDayCols,winterWeekEndCols:respResult.winterWeekEndCols,summerWeekDayCols:respResult.summerWeekDayCols,summerWeekEndCols:respResult.summerWeekEndCols, summerWeekDayEndSame:respResult.summerWeekDayEndSame,winterWeekDayEndSame:respResult.winterWeekDayEndSame, isDataLoading: false, rateCategory: response.rateCategory });}
            }}, (error) => {
                this.setState({ isError: true, isDataLoading: false });
});}
    setHourlyRankCols(peaks){
        let colGroup=[];
        let peakHourDifference = peaks.map(peak=>{
            return peak.split(':')[3];});
        let sorted = peakHourDifference.slice().sort(function(a,b){
            return b-a;});
        let ranks = peakHourDifference.map(function(v){
            return sorted.indexOf(v)+1;});
        switch(ranks.length){
            case 1: colGroup = ['col-sm-12'];
            break;
            case 2: colGroup = ['col-sm-6','col-sm-6'];     
            break;            
            case 3: colGroup =['col-sm-5','col-sm-3','col-sm-4'];
            break;
            case 4: colGroup =['col-sm-3 col-md-4','col-sm-3 col-md-3','col-sm-3 col-md-2','col-sm-3 col-md-3'];
            break;
            case 5: colGroup =['col-sm-3 col-md-3','col-sm-2 col-md-2','col-sm-2 col-md-2','col-sm-2 col-md-2','col-sm-3 col-md-3'];
            break;
            case 6: colGroup =['col-sm-2','col-sm-2','col-sm-2','col-sm-2','col-sm-2','col-sm-2'];
            break;}         
        return colGroup;}

formatReponseForTOU(response){
    let winterPeakValues=[], summerPeakValues=[], summerRateHours=[],winterRateHours=[], summerPeakTitle=[],winterPeakTitle=[],summerPeakWeekText=[],winterPeakWeekText=[], summerWeekDayPeak=[], summerWeekEndPeak=[], winterWeekDayPeak=[], winterWeekEndPeak=[], winterWeekDayCols=[],winterWeekEndCols=[],summerWeekDayCols=[],summerWeekEndCols=[], summerCompareCount = 0, winterCompareCount=0,summerWeekDayEndSame = false, winterWeekDayEndSame=false, result={};
    let summerPeakObjectNames = ['summerOnPeak','summerSuperOffPeak','summerMidPeak','summerOffPeak'];            
    let winterPeakObjectNames = ['winterSuperOffPeak','winterOnPeak','winterMidPeak','winterOffPeak'];  
    let summerPeakNames = ['On-Peak','Super Off-Peak','Mid-Peak','Off-Peak'];
    let winterPeakNames = ['Super Off-Peak','On-Peak','Mid-Peak','Off-Peak'];
    let summerClassNames = [styles.onPeak,styles.superOffPeak,styles.midPeak,styles.offPeak];
    let winterClassNames = [styles.superOffPeak,styles.onPeak,styles.midPeak,styles.offPeak];
    summerPeakObjectNames.forEach((peakObj, index)=>{
            if(response[peakObj]!==null && response[peakObj]!==undefined){
                let peakResponse = this.formatPeakResponse(response[peakObj],summerPeakNames[index],summerClassNames[index]);
                peakResponse.peakValues.map(a=>summerPeakValues.push(a));
                peakResponse.rateHours.map(a=>summerRateHours.push(a));
                peakResponse.peakTitle.map(a=>summerPeakTitle.push(a));
                peakResponse.weekText.map(a=>summerPeakWeekText.push(a));
                peakResponse.weekDayPeak.map(data=>summerWeekDayPeak.push(data));
                peakResponse.weekEndPeak.map(data=>summerWeekEndPeak.push(data));}});
    winterPeakObjectNames.forEach((peakObj, index)=>{
            if(response[peakObj]!==null && response[peakObj]!==undefined){
                let peakResponse = this.formatPeakResponse(response[peakObj],winterPeakNames[index],winterClassNames[index]);
                peakResponse.peakValues.map(a=>winterPeakValues.push(a));
                peakResponse.rateHours.map(a=>winterRateHours.push(a));
                peakResponse.peakTitle.map(a=>winterPeakTitle.push(a));
                peakResponse.weekText.map(a=>winterPeakWeekText.push(a));
                peakResponse.weekDayPeak.map(data=>winterWeekDayPeak.push(data));
                peakResponse.weekEndPeak.map(data=>winterWeekEndPeak.push(data));}});
    if(summerWeekDayPeak.length!==0){
        summerWeekDayPeak = this.sortPeak(summerWeekDayPeak);
        let hourlyRankCols = this.setHourlyRankCols(summerWeekDayPeak);
        summerWeekDayCols=hourlyRankCols;}
    if(summerWeekEndPeak.length!==0){
        summerWeekEndPeak = this.sortPeak(summerWeekEndPeak);
        let hourlyRankCols = this.setHourlyRankCols(summerWeekEndPeak);
        summerWeekEndCols=hourlyRankCols;}   
    if(winterWeekDayPeak.length!==0){
        winterWeekDayPeak = this.sortPeak(winterWeekDayPeak);
        let hourlyRankCols = this.setHourlyRankCols(winterWeekDayPeak);
        winterWeekDayCols=hourlyRankCols;}  
    if(winterWeekEndPeak.length!==0){
        winterWeekEndPeak = this.sortPeak(winterWeekEndPeak);
        let hourlyRankCols = this.setHourlyRankCols(winterWeekEndPeak);
        winterWeekEndCols=hourlyRankCols;}
    if((summerWeekDayPeak.length!==0) && (summerWeekEndPeak.length!==0) && (summerWeekDayPeak.length === summerWeekEndPeak.length)){
            summerWeekDayPeak.forEach((value,index)=>{
                if(value === summerWeekEndPeak[index]){
                summerCompareCount+=1;}});
             if(summerCompareCount === summerWeekDayPeak.length){
                summerWeekDayEndSame=true;}}
    if((winterWeekDayPeak.length!==0) && (winterWeekEndPeak.length!==0) && (winterWeekDayPeak.length === winterWeekEndPeak.length)){
        winterWeekDayPeak.forEach((value,index)=>{
                if(value === winterWeekEndPeak[index]){
                    winterCompareCount+=1;}});
        if(winterCompareCount === winterWeekDayPeak.length){
                winterWeekDayEndSame=true;}}
        result = {winterPeakValues, summerPeakValues, summerRateHours,winterRateHours,summerPeakTitle,winterPeakTitle,summerPeakWeekText,winterPeakWeekText,summerWeekDayPeak,summerWeekEndPeak,winterWeekDayPeak,winterWeekEndPeak,winterWeekDayCols,winterWeekEndCols,summerWeekDayCols,summerWeekEndCols,summerWeekDayEndSame,winterWeekDayEndSame}; 
        return result; }

formatPeakResponse=(peak,title,className)=>{
    let peakValues = [], rateHours = [], peakTitle=[], weekText=[], weekDayPeak = [], weekEndPeak = [], response={};
    let weekDayAvailable = this.findValueByPrefix(peak,"weekDay");
    let weekEndAvailable = this.findValueByPrefix(peak,"weekEnd");
    if(weekDayAvailable){
        peakValues.push(peak.weekDayPeakValue);
        rateHours.push(peak.weekDayPeakHours);
        peakTitle.push(title);
        weekText.push('(Weekdays Only)');
        let roundedPeakPrice=Math.round(peak.weekDayPeakValue);
        peak.weekDayPeakHours.map((hours)=>{
        let hourdifference=YourRatePlanGraphView.getHourDifference(hours);    
        let peakData=title+':'+hours+':'+roundedPeakPrice+':'+hourdifference+':'+className;
        weekDayPeak.push(peakData);});}
     if(weekEndAvailable){
        peakValues.push(peak.weekEndPeakValue);
        rateHours.push(peak.weekEndPeakHours);
        peakTitle.push(title);
        weekText.push('(Weekends Only)');
        let roundedPeakPrice=Math.round(peak.weekEndPeakValue);
        peak.weekEndPeakHours.map((hours)=>{
        let hourdifference=YourRatePlanGraphView.getHourDifference(hours); 
        let peakData=title+':'+hours+':'+roundedPeakPrice+':'+hourdifference+':'+className;
        weekEndPeak.push(peakData);});}
    if(!weekDayAvailable && !weekEndAvailable){
        peakValues.push(peak.peakValue);
        rateHours.push(peak.peakHours);
        peakTitle.push(title); 
        weekText.push('');
        let roundedPeakPrice=Math.round(peak.peakValue);
        peak.peakHours.map((hours)=>{
        let hourdifference=YourRatePlanGraphView.getHourDifference(hours); 
        let peakData=title+':'+hours+':'+roundedPeakPrice+':'+hourdifference+':'+className;
        weekDayPeak.push(peakData);
        weekEndPeak.push(peakData);});}
    response={peakValues,rateHours,peakTitle,weekText,weekDayPeak,weekEndPeak};
    return response;}

    findValueByPrefix = (peak, prefix) => {
        for (var property in peak) {
            if (peak.hasOwnProperty(property) && property.toString().startsWith(prefix)) {
                return true;}}
        return false;}
          
    getRatePlanContent = () => {
        let rateCategory = `<p id="ratePlan_${this.state.rateCategory}">(.*?)</p>`;
        let ratePlanRgx = new RegExp(rateCategory, 'g'); 
        let ratePlanContent = !_.isEmpty(this.props.content) ? this.props.content.body.match(ratePlanRgx) : "";
        return ratePlanContent ? ReactHtmlParser(ratePlanContent) : "";}

handleRateOptionChange = (event, valueSelected) => {
        let events = { alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Your Rate Plan'};
          app.analyticsService.addPageLevelData('eventCapturing', events);
        let isGraphOrTableView = this.props.isViewGraph ? 'graph' : 'table', selectedSeasonRate = valueSelected === 'Summer Rates' ? 'summer_rates' : 'winter_rates';
        window.aUtils ? window.aUtils.sendAAEvent("button", `usage|${this.props.selected}|${this.props.selectedOption}_${isGraphOrTableView}|your_rate_plan|page|${selectedSeasonRate}`) : null;
        const updatedState = { ...this.state };
        updatedState.ratePlanValuesTOU[0].subHeading = valueSelected === 'Summer Rates' ? 'On-Peak' : 'Super Off-Peak';
        this.setState({ selectedRateOption: valueSelected, updatedState });}

// TIER RATE CONTENT STARTS HERE
showTiercontent = () => {
    let tierRangeValues = !_.isEmpty(this.state.costDetails) && this.state.costDetails.hasOwnProperty('tier1ThresholdUsage') ? [`0-${this.state.costDetails.tier1ThresholdUsage.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} kWh`, `${(this.state.costDetails.tier1ThresholdUsage + 1).toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}-${this.state.costDetails.tier2ThresholdUsage.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} kWh`, `${(this.state.costDetails.tier2ThresholdUsage + 1).toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}+ kWh`] : [], yourRatePlanContent = this.getRatePlanContent(), showAsterisk = this.props.serviceProviderType;
    return (<div id='your_rate_plan' className='row'>
        {<div className='col-xs-12'>
            <div className={['sce-space-md', styles.sceFontSizeBig, styles.sceFontFamilyStackSans, styles.sceRatePopupContentPadding].join(" ")}> {this.state.rateCategoryType} </div>
            <div className={'sce-space-s ' + styles.sceRateBold + ' ' + styles.sceFontFamilyStackSans + ' ' + styles.sceRatePopupContentPadding}> {yourRatePlanContent}</div>
            <div className={'sce-space-md ' + styles.sceRatePopupContentPadding}> <AnchorTag linkName='Compare Rate Plans' isBold onClick={() => this.compareRatePlans()} /> </div> 
            <div className='sce-space-md'>{this.showGraphViewTier(tierRangeValues, showAsterisk, this.state.currentDate, this.state.cutOffDate)}</div>
             {this.props.serviceProviderType ? <div className={styles.sceTableIndicationText}>*Includes DELIVERY prices only. For GENERATION prices, please refer to your bill.</div> : null}
        </div>}</div>);}
//NBT3 R2 changes as part of October 2024 release.
showNBTAccount = () => {
    let nbtCheck = this.props.accountData.billingRateType.includes('NBT');
    return ( nbtCheck && !this.state.isError && !this.state.isPendingPaError && !this.state.isSingUpPAError ?
        <div className={[styles.sceNemPAalign, 'sce-space-md '].join(" ")}>
                <InfoPopup heading={this.nbtHeading} content='NBTratePlanPopup' />
                <div>                        
                    {this.props.vintageYear ? <div className='sce-space-xs'><span className={styles.sceVintageYearSpan}>Vintage year: {<span className={styles.sceYourBillCardTitle}>{this.props.vintageYear}</span>}</span><span className={styles.sceEECPricesSpan}><a className={styles.sceDownloadIcon}><i className="fa fa-solid fa-download" aria-hidden="true" /></a><AnchorTag link={drupalSettings.path.baseUrl + 'sites/default/files/inline-files/Price_EEC_Factors_Upload_File.xlsx'} linkName='EEC Prices' isUnderline /></span></div> : <span><a className={styles.sceDownloadIcon}><i className="fa fa-solid fa-download" aria-hidden="true" /></a><AnchorTag link={drupalSettings.path.baseUrl + 'sites/default/files/inline-files/Price_EEC_Factors_Upload_File.xlsx'} linkName='EEC Prices' isUnderline /></span>}
                    <div className='sce-space-xs'><span className={styles.sceYourBillBoldFontFamily}><AnchorTag onClick={()=>app.appUtil.navigateInNewTab("/residential/generating-your-own-power/solar-billing-plan/speak-solar")} linkName=' Learn How to speak solar' isUnderline /></span> </div>
                </div></div> : null); }
//TOU RATE CONTENT STARTS HERE
    showTOUcontent() {
    let yourRatePlanContent = this.getRatePlanContent(), showAsterisk = this.props.serviceProviderType;
    return (
        <div id='your_rate_plan' className='row'>
            <div className={'col-xs-12'}>
                {this.showNBTAccount()}
                <div className={['sce-space-md', styles.sceFontSizeBig, styles.sceFontFamilyStackSans, styles.sceRatePopupContentPadding].join(" ")}> {this.state.rateCategoryType} </div>
                <div className={'sce-space-s ' + styles.sceRateBold + ' ' + styles.sceFontFamilyStackSans + ' ' + styles.sceRatePopupContentPadding}>{yourRatePlanContent}</div>
            </div>
            <div className={'col-xs-12'}>
                <div className={'sce-space-md ' + styles.sceRatePopupContentPadding}>
                    <ToggleButton id={'usageRatePlan'} name={'rateRadio'} options={this.state.rateOptions} selectedOption={this.state.selectedRateOption} handleOptionChange={this.handleRateOptionChange} sceToggleBorder />
                </div>
                <div className={[styles.sceToggleMargin, styles.sceFontSizeMedium, styles.sceRatePopupContentPadding].join(" ")}> {this.state.selectedRateOption === 'Summer Rates' ? <span className={styles.sceSubTableHead}>  June – September </span> : <span className={styles.sceSubTableHead}> October – May </span>} </div>
                <div><div> {this.showGraphViewTOU(showAsterisk)} </div></div>
                {showAsterisk ? <div className={styles.sceTableIndicationText}>*Includes DELIVERY prices only. For GENERATION prices, please refer to your bill.</div> : null}
                {<div className={'sce-space-md ' + styles.sceRatePopupContentPadding}> <AnchorTag linkName='Compare Rate Plans' isBold onClick={() => this.compareRatePlans()} /> </div>}
            </div></div>);}

//TOU RATE CONTENT ENDS HERE
// FLAT RATE CONTENT STARTS HERE
// FLAT RATE CONTENT ENDS HERE

getContent = () => {
        switch (this.state.ratePlanResponse.isTierOrTOU) {
            case 'GS': return this.showFlatcontent();
            case 'TIER': return this.showTiercontent();
            default: return this.showTOUcontent();
        }}
    render() {
        return (<div className={styles.sceOverlay}>
        <div className={styles.sceOverlayContent}>
        <FocusTrap> 
        <div tabIndex="0">
            <div>
                <div ref={this.setWrapperRef} tabIndex="0" className={styles.scePopupBox}>
                    <div className={styles.scePopUpTitleArea}>
                        <span><button className={styles.sceIconClose} onClick={() => this.props.ratePlanOpenClosePopup('close')}><img src={this.closeIcon} alt="Close Icon" /></button></span>
                            <div className={styles.sceHeader}>Your Rate Plan</div>
                    </div>
                    <div className={styles.sceGreyAddressBox}>
                                        <h1 data-pii-encrypt className={styles.sceGreyBoxAddressLine}>{this.props.serviceStreetAddress}</h1>
                    </div>
                    <div className={styles.scePopupContentArea}>
                    <div className={styles.scePopupContent}>
                        <div>
                            {this.state.isDataLoading ? <div className="sce-space-lg"><LoadIndicator showLoading /></div> : !_.isEmpty(this.state.ratePlanResponse) ? this.getContent() : <ErrorCard cardName={'Your Rate Plan'} errorMsg={"Rate Plan details is temporarily unavailable. Please check back soon."} fetchAccountDetails={this.fetchRatePlan} />}
                        </div></div>
                    </div></div></div>
    </div></FocusTrap></div></div>);}}
